function safeJSONParse(str: string) {
  try {
    return JSON.parse(str);
  } catch (e) {
    // swallow error
  }
}

export { safeJSONParse };
